import getQueryList from './getQueryList';

export default function checkIsTicketGroupShownInQuery(ticketGroupReference, query) {
  if (!query.show_ticket_groups) return false;

  return getQueryList(query.show_ticket_groups).includes(ticketGroupReference);
}
